import React from "react";
import { FaSearch, FaSortAmountDown } from "react-icons/fa";
import { getFPOData } from "../../helpers/local_storage_helpers";

/**
 * Shared list-page header — title + FPO subtitle on the left,
 * search / sort / primary action on the right.
 *
 * Search, sort and the action button are all optional — omit the
 * corresponding props on pages that don't need them.
 */
const PageHeader = ({
    title,
    search,
    onSearchChange,
    searchPlaceholder = "Search…",
    onSort,
    actionLabel,
    actionIcon: ActionIcon,
    onAction,
    children,
}) => {
    const fpo      = getFPOData() || {};
    const subtitle = [fpo.name, [fpo.district, fpo.state].filter(Boolean).join(", ")]
        .filter(Boolean)
        .join(" · ");

    return (
        <div className="sticky top-0 z-20 bg-white border-b border-gray-200 -mx-4 -mt-4 mb-5 px-4 sm:px-6 py-4 flex flex-col gap-3">
            <div className="flex items-center justify-between flex-wrap gap-3">
                <div>
                    <h1 className="text-gray-900 text-lg font-bold">{title}</h1>
                    {subtitle && <p className="text-gray-400 text-xs mt-0.5">{subtitle}</p>}
                </div>

                <div className="flex items-center gap-2.5 flex-wrap">
                    {onSearchChange && (
                        <div className="relative">
                            <FaSearch className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-300 text-xs" />
                            <input
                                type="text"
                                value={search}
                                onChange={(e) => onSearchChange(e.target.value)}
                                placeholder={searchPlaceholder}
                                className="w-64 sm:w-80 pl-9 pr-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary bg-gray-50 text-gray-800 placeholder:text-gray-400"
                            />
                        </div>
                    )}

                    {onSort && (
                        <button
                            type="button"
                            onClick={onSort}
                            title="Sort"
                            className="w-9 h-9 flex items-center justify-center border border-gray-200 rounded-xl text-gray-500 hover:bg-gray-50 transition-colors flex-shrink-0"
                        >
                            <FaSortAmountDown size={12} />
                        </button>
                    )}

                    {actionLabel && (
                        <button
                            type="button"
                            onClick={onAction}
                            className="flex items-center gap-2 bg-primary hover:bg-green-600 text-white text-sm font-medium px-4 py-2 rounded-xl transition-colors cursor-pointer flex-shrink-0"
                        >
                            {ActionIcon && <ActionIcon className="text-xs" />}
                            {actionLabel}
                        </button>
                    )}
                </div>
            </div>

            {children && (
                <div className="flex items-center justify-between flex-wrap gap-3">
                    {children}
                </div>
            )}
        </div>
    );
};

export default PageHeader;
